import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import ModalArticleType from "./LesModals/ModalArticleType";
import ArticleTypeTable from "./LesTable/ArticleTypeTable";

const ArticleType: React.FC = () => {
  return (
    <div className="container-table-location">
      <button
        type="button"
        data-toggle="modal"
        data-target="#ProprietetypeModal"
        className="btn btn-add-amin-setting ml-auto"
      >
        <AiOutlinePlusCircle className="btn-addadmin-icon" />
        <span className="">Add Article Type</span>
      </button>
      <div
        className="modal fade modal-faq modal-faq-contact"
        id="ProprietetypeModal"
        aria-labelledby="addAdminModalLabel"
        aria-hidden="true"
      >
        <ModalArticleType />
      </div>
      <div className="profile-containers">
        <div className="containter-table-admin mt-5">
          <ArticleTypeTable />
        </div>
      </div>
    </div>
  );
};

export default ArticleType;
